import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  "class": "TUIChat-main"
};
var _hoisted_2 = {
  "class": "TUIChat-safe-tips"
};
var _hoisted_3 = {
  "class": "application-tips-btn"
};
var _hoisted_4 = ["id"];
var _hoisted_5 = ["onLongpress", "onContextmenu", "onTouchstart", "onTouchend", "onMouseover"];
var _hoisted_6 = {
  "class": "delDialog-title"
};
import { ref, nextTick, computed, onMounted, onUnmounted } from "../../../adapter-vue";
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService, TUIChatService, TUIGroupService } from "@tencentcloud/chat-uikit-engine";
import { throttle } from "lodash";
import Link from "./link";
import MessageText from "./message-elements/message-text.vue";
import MessageImage from "./message-elements/message-image.vue";
import MessageAudio from "./message-elements/message-audio.vue";
import MessageFile from "./message-elements/message-file.vue";
import MessageFace from "./message-elements/message-face.vue";
import MessageCustom from "./message-elements/message-custom.vue";
import MessageTip from "./message-elements/message-tip.vue";
import MessageBubble from "./message-elements/message-bubble.vue";
import MessageLocation from "./message-elements/message-location.vue";
import MessageTimestamp from "./message-elements/message-timestamp.vue";
import MessageVideo from "./message-elements/message-video.vue";
import MessageTool from "./message-tool/index.vue";
import MessageRevoked from "./message-tool/message-revoked.vue";
import MessagePlugin from "../../../plugins/plugin-components/message-plugin.vue";
import ScrollButton from "./scroll-button/index.vue";
import ReadReciptPanel from "./read-receipt-panel/index.vue";
import { isPluginMessage } from "../../../plugins/plugin-components/index";
import MessageGroupSystem from "./message-elements/message-group-system.vue";
import Dialog from "../../common/Dialog/index.vue";
import ImagePreviewer from "../../common/ImagePreviewer/index.vue";
import ProgressMessage from "../../common/ProgressMessage/index.vue";
import { isCreateGroupCustomMessage } from "../utils/utils";
import { getBoundingClientRect, getScrollInfo } from "../../../utils/universal-api/domOperation";
import { isPC, isH5 } from "../../../utils/env";
import { isEnabledMessageReadReceiptGlobal } from "../utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    groupID: {
      type: String,
      "default": ""
    },
    isGroup: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["handleEditor"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var observer = null;
    var groupType;
    var sentReceiptMessageIDSet = new Set();
    var messageListRef = ref();
    // 上屏展示 messageList，不包含 isDeleted 为 true 的 message
    var messageList = ref();
    // 所有 messageList 序列，包含 isDeleted 为 true 的 message
    var allMessageList = ref();
    var isCompleted = ref(false);
    var currentConversationID = ref("");
    var currentLastMessage = ref();
    var currentLastMessageTime = ref(0);
    var nextReqMessageID = ref();
    var toggleID = ref("");
    var TYPES = ref(TUIChatEngine.TYPES);
    var isLongpressing = ref(false);
    var groupApplicationCount = ref(0);
    var showGroupApplication = ref(false);
    var applicationUserIDList = ref([]);
    var messageTarget = ref();
    var messageElementListRef = ref();
    var blinkMessageIDList = ref([]);
    var scrollButtonInstanceRef = ref();
    var isShowReadUserStatusPanel = ref(false);
    var readStatusMessage = ref();
    var beforeHistoryGetScrollHeight = ref(0);
    // 图片预览相关
    var showImagePreview = ref(false);
    var currentImagePreview = ref();
    var imageMessageList = computed(function () {
      var _messageList$value;
      return messageList === null || messageList === void 0 || (_messageList$value = messageList.value) === null || _messageList$value === void 0 ? void 0 : _messageList$value.filter(function (item) {
        return !item.isRevoked && !item.hasRiskContent && item.type === TYPES.value.MSG_IMAGE;
      });
    });
    // 消息重发 Dialog
    var reSendDialogShow = ref(false);
    var resendMessageData = ref();
    // 事件监听
    onMounted(function () {
      // 消息 messageList
      TUIStore.watch(StoreName.CHAT, {
        messageList: onMessageListUpdated,
        messageSource: onMessageSourceUpdated,
        isCompleted: isCompletedUpdated
      });
      // 当前 ConversationID
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated
      });
      // 群未决消息列表
      TUIStore.watch(StoreName.GRP, {
        groupSystemNoticeList: onGroupSystemNoticeList
      });
      // 群未决消息数量
      TUIStore.watch(StoreName.CUSTOM, {
        groupApplicationCount: groupApplicationCountUpdated
      });
    });
    // 绑定监听滚动事件 展示scroll-button
    onMounted(function () {
      var _messageListRef$value;
      (_messageListRef$value = messageListRef.value) === null || _messageListRef$value === void 0 || _messageListRef$value.addEventListener("scroll", handelScrollListScroll);
    });
    // 取消监听
    onUnmounted(function () {
      var _messageListRef$value2, _observer;
      TUIStore.unwatch(StoreName.CHAT, {
        messageList: onMessageListUpdated,
        messageSource: onMessageSourceUpdated,
        isCompleted: isCompletedUpdated
      });
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated,
        currentConversation: onCurrentConversationUpdated
      });
      TUIStore.unwatch(StoreName.GRP, {
        groupSystemNoticeList: onGroupSystemNoticeList
      });
      (_messageListRef$value2 = messageListRef.value) === null || _messageListRef$value2 === void 0 || _messageListRef$value2.removeEventListener("scroll", handelScrollListScroll);
      sentReceiptMessageIDSet.clear();
      (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
      observer = null;
    });
    function onMessageListUpdated(_x) {
      return _onMessageListUpdated.apply(this, arguments);
    }
    function _onMessageListUpdated() {
      _onMessageListUpdated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(list) {
        var _observer2, _messageList$value2, _messageList$value3, _messageList$value4;
        var oldLastMessage, newLastMessage, _messageList$value5, tempMessage;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              (_observer2 = observer) === null || _observer2 === void 0 || _observer2.disconnect();
              oldLastMessage = currentLastMessage.value;
              allMessageList.value = list;
              messageList.value = list.filter(function (message) {
                return !message.isDeleted;
              });
              if ((_messageList$value2 = messageList.value) !== null && _messageList$value2 !== void 0 && _messageList$value2.length) {
                _context.next = 7;
                break;
              }
              currentLastMessage.value = {};
              return _context.abrupt("return");
            case 7:
              newLastMessage = (_messageList$value3 = messageList.value) === null || _messageList$value3 === void 0 ? void 0 : _messageList$value3[((_messageList$value4 = messageList.value) === null || _messageList$value4 === void 0 ? void 0 : _messageList$value4.length) - 1];
              if (!messageTarget.value) {
                _context.next = 18;
                break;
              }
              if (!(((_messageList$value5 = messageList.value) === null || _messageList$value5 === void 0 ? void 0 : _messageList$value5.findIndex(function (message) {
                var _messageTarget$value;
                return (message === null || message === void 0 ? void 0 : message.ID) === ((_messageTarget$value = messageTarget.value) === null || _messageTarget$value === void 0 ? void 0 : _messageTarget$value.ID);
              })) >= 0)) {
                _context.next = 16;
                break;
              }
              tempMessage = messageTarget.value;
              messageTarget.value = undefined;
              _context.next = 14;
              return scrollToPosition({
                scrollToMessage: tempMessage
              });
            case 14:
              _context.next = 16;
              return blinkMessage(tempMessage === null || tempMessage === void 0 ? void 0 : tempMessage.ID);
            case 16:
              _context.next = 27;
              break;
            case 18:
              if (!beforeHistoryGetScrollHeight.value) {
                _context.next = 24;
                break;
              }
              _context.next = 21;
              return scrollToPosition({
                scrollToOffset: {
                  bottom: beforeHistoryGetScrollHeight.value
                }
              });
            case 21:
              beforeHistoryGetScrollHeight.value = 0;
              _context.next = 27;
              break;
            case 24:
              if (!(newLastMessage !== null && newLastMessage !== void 0 && newLastMessage.ID && JSON.stringify(oldLastMessage) !== JSON.stringify(newLastMessage))) {
                _context.next = 27;
                break;
              }
              _context.next = 27;
              return scrollToPosition({
                scrollToBottom: true
              });
            case 27:
              currentLastMessage.value = Object.assign({}, newLastMessage);
              if (isEnabledMessageReadReceiptGlobal()) {
                nextTick(function () {
                  return bindIntersectionObserver();
                });
              }
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onMessageListUpdated.apply(this, arguments);
    }
    function scrollToPosition() {
      return _scrollToPosition.apply(this, arguments);
    }
    function _scrollToPosition() {
      _scrollToPosition = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var config,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              config = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                requestAnimationFrame(function () {
                  if (!messageListRef.value) {
                    reject();
                  }
                  var container = messageListRef.value;
                  if (config.scrollToBottom) {
                    container.scrollTop = container.scrollHeight;
                  } else if (config.scrollToMessage) {
                    var _messageElementListRe;
                    var targetMessageDom = (_messageElementListRe = messageElementListRef.value) === null || _messageElementListRe === void 0 ? void 0 : _messageElementListRe.find(function (dom) {
                      var _config$scrollToMessa;
                      return (dom === null || dom === void 0 ? void 0 : dom.id) === "tui-".concat((_config$scrollToMessa = config.scrollToMessage) === null || _config$scrollToMessa === void 0 ? void 0 : _config$scrollToMessa.ID);
                    });
                    if (targetMessageDom !== null && targetMessageDom !== void 0 && targetMessageDom.scrollIntoView) {
                      targetMessageDom.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                      });
                    }
                  } else if (config.scrollToOffset) {
                    var _config$scrollToOffse, _config$scrollToOffse2;
                    if ((_config$scrollToOffse = config.scrollToOffset) !== null && _config$scrollToOffse !== void 0 && _config$scrollToOffse.top) {
                      container.scrollTop = config.scrollToOffset.top;
                    } else if ((_config$scrollToOffse2 = config.scrollToOffset) !== null && _config$scrollToOffse2 !== void 0 && _config$scrollToOffse2.bottom) {
                      container.scrollTop = container.scrollHeight - config.scrollToOffset.bottom;
                    }
                  }
                  resolve();
                });
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _scrollToPosition.apply(this, arguments);
    }
    function onMessageSourceUpdated(_x2) {
      return _onMessageSourceUpdated.apply(this, arguments);
    }
    function _onMessageSourceUpdated() {
      _onMessageSourceUpdated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(message) {
        var _messageList$value6, tempMessage;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // messageSource change 有两种情况
              // 1. messageSource change -> 未命中缓存 -> messageList change,
              // 2. messageSource change -> 命中缓存 -> messageList not change
              // 只有第二种情况需要在此处监听时增加 scrollToTarget
              messageTarget.value = message;
              if (!messageTarget.value) {
                _context3.next = 9;
                break;
              }
              if (!(((_messageList$value6 = messageList.value) === null || _messageList$value6 === void 0 ? void 0 : _messageList$value6.findIndex(function (message) {
                var _messageTarget$value2;
                return (message === null || message === void 0 ? void 0 : message.ID) === ((_messageTarget$value2 = messageTarget.value) === null || _messageTarget$value2 === void 0 ? void 0 : _messageTarget$value2.ID);
              })) >= 0)) {
                _context3.next = 9;
                break;
              }
              tempMessage = messageTarget.value;
              messageTarget.value = undefined;
              _context3.next = 7;
              return scrollToPosition({
                scrollToMessage: tempMessage
              });
            case 7:
              _context3.next = 9;
              return blinkMessage(tempMessage === null || tempMessage === void 0 ? void 0 : tempMessage.ID);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _onMessageSourceUpdated.apply(this, arguments);
    }
    function isCompletedUpdated(flag) {
      isCompleted.value = flag;
    }
    function groupApplicationCountUpdated(count) {
      groupApplicationCount.value = count;
    }
    // 监听回调函数
    var onCurrentConversationIDUpdated = function onCurrentConversationIDUpdated(conversationID) {
      currentConversationID.value = conversationID;
      messageList.value = [];
      // 获取加群系统消息列表
      TUIGroupService.getGroupApplicationList().then(function (res) {
        var applicationList = res.data.applicationList.filter(function (application) {
          return application.groupID === props.groupID;
        });
        applicationUserIDList.value = applicationList.map(function (application) {
          return application.applicationType === 0 ? application.applicant : application.userID;
        });
        TUIStore.update(StoreName.CUSTOM, "groupApplicationCount", applicationList.length);
      });
      // 开启已读回执的状态 群聊缓存群类型
      if (isEnabledMessageReadReceiptGlobal()) {
        var _ref2 = TUIStore.getConversationModel(conversationID) || {},
          groupProfile = _ref2.groupProfile;
        groupType = groupProfile === null || groupProfile === void 0 ? void 0 : groupProfile.type;
      }
    };
    var onCurrentConversationUpdated = function onCurrentConversationUpdated(conversation) {
      var _conversation$lastMes;
      currentLastMessageTime.value = (conversation === null || conversation === void 0 || (_conversation$lastMes = conversation.lastMessage) === null || _conversation$lastMes === void 0 ? void 0 : _conversation$lastMes.lastTime) || 0;
    };
    // operationType 操作类型 1: 有用户申请加群   23: 普通群成员邀请用户进群
    var onGroupSystemNoticeList = function onGroupSystemNoticeList(list) {
      var systemNoticeList = list.filter(function (message) {
        var operationType = message.payload.operationType;
        return (operationType === 1 || operationType === 23) && message.to === props.groupID;
      });
      systemNoticeList.forEach(function (systemNotice) {
        var operationType = systemNotice.payload.operationType;
        if (operationType === 1) {
          var operatorID = systemNotice.payload.operatorID;
          if (!applicationUserIDList.value.includes(operatorID)) {
            applicationUserIDList.value.push(operatorID);
          }
        }
        if (operationType === 23) {
          var inviteeList = systemNotice.payload.inviteeList;
          inviteeList.forEach(function (invitee) {
            if (!applicationUserIDList.value.includes(invitee)) {
              applicationUserIDList.value.push(invitee);
            }
          });
        }
      });
      var applicationCount = applicationUserIDList.value.length;
      TUIStore.update(StoreName.CUSTOM, "groupApplicationCount", applicationCount);
    };
    var toggleApplicationList = function toggleApplicationList() {
      showGroupApplication.value = !showGroupApplication.value;
    };
    var handleGroupApplication = function handleGroupApplication(userID) {
      var index = applicationUserIDList.value.indexOf(userID);
      if (index !== -1) {
        applicationUserIDList.value.splice(index, 1);
      }
    };
    // 获取历史消息
    var getHistoryMessageList = function getHistoryMessageList() {
      var _messageListRef$value3;
      TUIChatService.getMessageList().then(function (res) {
        var ID = res.data.nextReqMessageID;
        nextReqMessageID.value = ID;
      });
      // 获取历史消息后，保持滚动条在原来位置
      beforeHistoryGetScrollHeight.value = (_messageListRef$value3 = messageListRef.value) === null || _messageListRef$value3 === void 0 ? void 0 : _messageListRef$value3.scrollHeight;
    };
    var openComplaintLink = function openComplaintLink(type) {
      window.open(type.url);
    };
    // 图片预览
    var handleImagePreview = function handleImagePreview(message) {
      if (showImagePreview.value || currentImagePreview.value || isLongpressing.value) {
        return;
      }
      showImagePreview.value = true;
      currentImagePreview.value = message;
    };
    // 关闭图片预览
    var onImagePreviewerClose = function onImagePreviewerClose() {
      showImagePreview.value = false;
      currentImagePreview.value = null;
    };
    // 消息操作
    var handleToggleMessageItem = function handleToggleMessageItem(e, message) {
      var isLongpress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (isLongpress) {
        isLongpressing.value = true;
      }
      toggleID.value = message.ID;
    };
    var handleToggleMessageItemForPC = function handleToggleMessageItemForPC(e, message) {
      if (isPC) {
        toggleID.value = message.ID;
      }
    };
    // h5 long press
    var timer;
    var handleH5LongPress = function handleH5LongPress(e, message, type) {
      if (!isH5) return;
      function longPressHandler() {
        clearTimeout(timer);
        handleToggleMessageItem(e, message);
      }
      function touchStartHandler() {
        timer = setTimeout(longPressHandler, 500);
      }
      function touchEndHandler() {
        clearTimeout(timer);
      }
      switch (type) {
        case "touchstart":
          touchStartHandler();
          break;
        case "touchend":
          touchEndHandler();
          setTimeout(function () {
            isLongpressing.value = false;
          }, 200);
          break;
      }
    };
    // 消息撤回后，编辑消息
    var handleEdit = function handleEdit(message) {
      emits("handleEditor", message, "reedit");
    };
    // 重发消息
    var resendMessage = function resendMessage(message) {
      reSendDialogShow.value = true;
      resendMessageData.value = message;
    };
    var resendMessageConfirm = function resendMessageConfirm() {
      reSendDialogShow.value = !reSendDialogShow.value;
      var messageModel = resendMessageData.value;
      messageModel.resendMessage();
    };
    function blinkMessage(messageID) {
      return new Promise(function (resolve) {
        var index = blinkMessageIDList.value.indexOf(messageID);
        if (index < 0) {
          blinkMessageIDList.value.push(messageID);
          var _timer = setTimeout(function () {
            blinkMessageIDList.value.splice(blinkMessageIDList.value.indexOf(messageID), 1);
            clearTimeout(_timer);
            resolve();
          }, 3000);
        }
      });
    }
    // 滚动到最新消息
    function scrollToLatestMessage() {
      return _scrollToLatestMessage.apply(this, arguments);
    }
    function _scrollToLatestMessage() {
      _scrollToLatestMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$getScrollInfo, scrollHeight, _yield$getBoundingCli, height;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getScrollInfo('#messageScrollList');
            case 2:
              _yield$getScrollInfo = _context4.sent;
              scrollHeight = _yield$getScrollInfo.scrollHeight;
              _context4.next = 6;
              return getBoundingClientRect('#messageScrollList');
            case 6:
              _yield$getBoundingCli = _context4.sent;
              height = _yield$getBoundingCli.height;
              if (messageListRef.value) {
                messageListRef.value.scrollTop = scrollHeight - height;
              }
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _scrollToLatestMessage.apply(this, arguments);
    }
    var handelScrollListScroll = throttle(function (e) {
      var _scrollButtonInstance;
      (_scrollButtonInstance = scrollButtonInstanceRef.value) === null || _scrollButtonInstance === void 0 || _scrollButtonInstance.judgeScrollOverOneScreen(e);
    }, 150, {
      leading: true
    });
    function bindIntersectionObserver() {
      return _bindIntersectionObserver.apply(this, arguments);
    }
    function _bindIntersectionObserver() {
      _bindIntersectionObserver = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _observer3, _messageListRef$value4;
        var mappingFromIDToMessage, arrayOfMessageLi, _loop, i;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(messageList.value.length === 0)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              if (!(groupType === TYPES.value.GRP_AVCHATROOM || groupType === TYPES.value.GRP_COMMUNITY)) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return");
            case 4:
              mappingFromIDToMessage = {};
              (_observer3 = observer) === null || _observer3 === void 0 || _observer3.disconnect();
              observer = new IntersectionObserver(function (entries, _) {
                entries.forEach(function (entry) {
                  var isIntersecting = entry.isIntersecting,
                    target = entry.target;
                  if (isIntersecting) {
                    var _msgModel$readReceipt;
                    var _mappingFromIDToMessa = mappingFromIDToMessage[target.id],
                      msgDom = _mappingFromIDToMessa.msgDom,
                      msgModel = _mappingFromIDToMessa.msgModel;
                    if (msgModel && !((_msgModel$readReceipt = msgModel.readReceiptInfo) !== null && _msgModel$readReceipt !== void 0 && _msgModel$readReceipt.isPeerRead) && !sentReceiptMessageIDSet.has(msgModel.ID)) {
                      var _observer4;
                      TUIChatService.sendMessageReadReceipt([msgModel]);
                      sentReceiptMessageIDSet.add(msgModel.ID);
                      (_observer4 = observer) === null || _observer4 === void 0 || _observer4.unobserve(msgDom);
                    }
                  }
                });
              }, {
                root: messageListRef.value,
                threshold: 0.7
              });
              arrayOfMessageLi = (_messageListRef$value4 = messageListRef.value) === null || _messageListRef$value4 === void 0 ? void 0 : _messageListRef$value4.querySelectorAll('.message-li');
              if (!arrayOfMessageLi) {
                _context6.next = 16;
                break;
              }
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var messageElement, matchingMessage, _observer5;
                return _regeneratorRuntime().wrap(function _loop$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      messageElement = arrayOfMessageLi[i];
                      matchingMessage = messageList.value.find(function (message) {
                        return messageElement.id.slice(4) === message.ID;
                      });
                      if (matchingMessage && matchingMessage.needReadReceipt && matchingMessage.flow === 'in') {
                        mappingFromIDToMessage[messageElement.id] = {
                          msgDom: messageElement,
                          msgModel: matchingMessage
                        };
                        (_observer5 = observer) === null || _observer5 === void 0 || _observer5.observe(messageElement);
                      }
                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 11:
              if (!(i < (arrayOfMessageLi === null || arrayOfMessageLi === void 0 ? void 0 : arrayOfMessageLi.length))) {
                _context6.next = 16;
                break;
              }
              return _context6.delegateYield(_loop(), "t0", 13);
            case 13:
              ++i;
              _context6.next = 11;
              break;
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee5);
      }));
      return _bindIntersectionObserver.apply(this, arguments);
    }
    var isSignalingMessage = function isSignalingMessage(message) {
      return (message === null || message === void 0 ? void 0 : message.type) === TYPES.value.MSG_CUSTOM && (message === null || message === void 0 ? void 0 : message.getSignalingInfo());
    };
    function setReadReciptPanelVisible(visible, message) {
      if (!visible) {
        readStatusMessage.value = undefined;
      } else {
        readStatusMessage.value = message;
      }
      isShowReadUserStatusPanel.value = visible;
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["TUIChat", [!_unref(isPC) ? 'TUIChat-H5' : '']])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUIChat.【安全提示】本 APP 仅用于体验腾讯云即时通信 IM 产品功能，不可用于业务洽谈与拓展。请勿轻信汇款、中奖等涉及钱款的信息，勿轻易拨打陌生电话，谨防上当受骗。")), 1), _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return openComplaintLink(_unref(Link).complaint);
        })
      }, _toDisplayString(_unref(TUITranslateService).t("TUIChat.点此投诉")), 1)]), __props.isGroup && _unref(groupApplicationCount) > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "TUIChat-application-tips",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return toggleApplicationList();
        })
      }, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(_unref(groupApplicationCount)) + _toDisplayString(_unref(TUITranslateService).t("TUIChat.条入群申请")) + " ", 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("TUIChat.点击处理")), 1)])])) : _createCommentVNode("", true), _createElementVNode("ul", {
        "class": "TUI-message-list",
        ref_key: "messageListRef",
        ref: messageListRef,
        id: "messageScrollList"
      }, [!_unref(isCompleted) ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        "class": "message-more",
        onClick: getHistoryMessageList
      }, _toDisplayString(_unref(TUITranslateService).t("TUIChat.查看更多")), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageList), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: item.ID,
          id: 'tui-' + item.ID,
          ref_for: true,
          ref_key: "messageElementListRef",
          ref: messageElementListRef,
          "class": "message-li"
        }, [_createVNode(MessageTimestamp, {
          currTime: item.time,
          prevTime: index > 0 ? _unref(messageList)[index - 1].time : 0
        }, null, 8, ["currTime", "prevTime"]), _createElementVNode("div", {
          "class": "message-item",
          onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
            return toggleID.value = '';
          }, ["stop"]))
        }, [item.type === _unref(TYPES).MSG_GRP_TIP || _unref(isCreateGroupCustomMessage)(item) ? (_openBlock(), _createBlock(MessageTip, {
          key: 0,
          content: item.getMessageContent(),
          blinkMessageIDList: _unref(blinkMessageIDList),
          onBlinkMessage: blinkMessage
        }, null, 8, ["content", "blinkMessageIDList"])) : !item.isRevoked && !_unref(isPluginMessage)(item) ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onLongpress: function onLongpress($event) {
            return handleToggleMessageItem($event, item, true);
          },
          onContextmenu: _withModifiers(function ($event) {
            return handleToggleMessageItemForPC($event, item);
          }, ["prevent", "right"]),
          onTouchstart: function onTouchstart($event) {
            return handleH5LongPress($event, item, 'touchstart');
          },
          onTouchend: function onTouchend($event) {
            return handleH5LongPress($event, item, 'touchend');
          },
          onMouseover: function onMouseover($event) {
            return handleH5LongPress($event, item, 'touchend');
          }
        }, [_createVNode(MessageBubble, {
          messageItem: item,
          content: item.getMessageContent(),
          blinkMessageIDList: _unref(blinkMessageIDList),
          onResendMessage: function onResendMessage($event) {
            return resendMessage(item);
          },
          onBlinkMessage: blinkMessage,
          onSetReadReciptPanelVisible: setReadReciptPanelVisible
        }, {
          "default": _withCtx(function () {
            return [item.type === _unref(TYPES).MSG_TEXT ? (_openBlock(), _createBlock(MessageText, {
              key: 0,
              content: item.getMessageContent()
            }, null, 8, ["content"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_IMAGE ? (_openBlock(), _createBlock(ProgressMessage, {
              key: 1,
              content: item.getMessageContent(),
              messageItem: item
            }, {
              "default": _withCtx(function () {
                return [_createVNode(MessageImage, {
                  content: item.getMessageContent(),
                  messageItem: item,
                  onPreviewImage: handleImagePreview
                }, null, 8, ["content", "messageItem"])];
              }),
              _: 2
            }, 1032, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_VIDEO ? (_openBlock(), _createBlock(ProgressMessage, {
              key: 2,
              content: item.getMessageContent(),
              messageItem: item
            }, {
              "default": _withCtx(function () {
                return [_createVNode(MessageVideo, {
                  content: item.getMessageContent(),
                  messageItem: item
                }, null, 8, ["content", "messageItem"])];
              }),
              _: 2
            }, 1032, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_AUDIO ? (_openBlock(), _createBlock(MessageAudio, {
              key: 3,
              content: item.getMessageContent(),
              messageItem: item
            }, null, 8, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_FILE ? (_openBlock(), _createBlock(ProgressMessage, {
              key: 4,
              content: item.getMessageContent(),
              messageItem: item
            }, {
              "default": _withCtx(function () {
                return [_createVNode(MessageFile, {
                  content: item.getMessageContent(),
                  messageItem: item
                }, null, 8, ["content", "messageItem"])];
              }),
              _: 2
            }, 1032, ["content", "messageItem"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_FACE ? (_openBlock(), _createBlock(MessageFace, {
              key: 5,
              content: item.getMessageContent(),
              isPC: _unref(isPC)
            }, null, 8, ["content", "isPC"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_LOCATION ? (_openBlock(), _createBlock(MessageLocation, {
              key: 6,
              content: item.getMessageContent()
            }, null, 8, ["content"])) : _createCommentVNode("", true), item.type === _unref(TYPES).MSG_CUSTOM ? (_openBlock(), _createBlock(MessageCustom, {
              key: 7,
              content: item.getMessageContent(),
              messageItem: item
            }, null, 8, ["content", "messageItem"])) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1032, ["messageItem", "content", "blinkMessageIDList", "onResendMessage"])], 40, _hoisted_5)) : !item.isRevoked && _unref(isPluginMessage)(item) ? (_openBlock(), _createBlock(MessagePlugin, {
          key: 2,
          message: item,
          blinkMessageIDList: _unref(blinkMessageIDList),
          onResendMessage: resendMessage,
          onHandleToggleMessageItem: handleToggleMessageItem,
          onHandleH5LongPress: handleH5LongPress
        }, null, 8, ["message", "blinkMessageIDList"])) : (_openBlock(), _createBlock(MessageRevoked, {
          key: 3,
          isEdit: item.type === _unref(TYPES).MSG_TEXT,
          messageItem: item,
          onMessageEdit: function onMessageEdit($event) {
            return handleEdit(item);
          }
        }, null, 8, ["isEdit", "messageItem", "onMessageEdit"])), item.ID === _unref(toggleID) ? (_openBlock(), _createBlock(MessageTool, {
          key: 4,
          "class": _normalizeClass(['message-tool', item.flow === 'out' ? 'message-tool-out' : 'message-tool-in']),
          messageItem: item
        }, null, 8, ["class", "messageItem"])) : _createCommentVNode("", true)])], 8, _hoisted_4);
      }), 128))], 512), _createVNode(ScrollButton, {
        ref_key: "scrollButtonInstanceRef",
        ref: scrollButtonInstanceRef,
        onScrollToLatestMessage: scrollToLatestMessage
      }, null, 512), _unref(reSendDialogShow) ? (_openBlock(), _createBlock(Dialog, {
        key: 1,
        "class": "resend-dialog",
        show: _unref(reSendDialogShow),
        isH5: !_unref(isPC),
        center: true,
        isHeaderShow: _unref(isPC),
        onSubmit: _cache[3] || (_cache[3] = function ($event) {
          return resendMessageConfirm();
        }),
        "onUpdate:show": _cache[4] || (_cache[4] = function (e) {
          return reSendDialogShow.value = e;
        })
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("p", _hoisted_6, _toDisplayString(_unref(TUITranslateService).t("TUIChat.确认重发该消息？")), 1)];
        }),
        _: 1
      }, 8, ["show", "isH5", "isHeaderShow"])) : _createCommentVNode("", true), _unref(showImagePreview) ? (_openBlock(), _createBlock(ImagePreviewer, {
        key: 2,
        currentImage: _unref(currentImagePreview),
        imageList: _unref(imageMessageList),
        onClose: onImagePreviewerClose
      }, null, 8, ["currentImage", "imageList"])) : _createCommentVNode("", true), _unref(showGroupApplication) ? (_openBlock(), _createBlock(MessageGroupSystem, {
        key: 3,
        groupID: __props.groupID,
        onToggleApplicationList: toggleApplicationList,
        onHandleGroupApplication: handleGroupApplication
      }, null, 8, ["groupID"])) : _createCommentVNode("", true), _unref(isShowReadUserStatusPanel) ? (_openBlock(), _createBlock(ReadReciptPanel, {
        key: 4,
        message: Object.assign({}, _unref(readStatusMessage)),
        onSetReadReciptPanelVisible: setReadReciptPanelVisible
      }, null, 8, ["message"])) : _createCommentVNode("", true)])], 2);
    };
  }
});